module.exports = __webpack_public_path__ + "static/img/product_onboarding.5eec0565.png";